import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon BackArrowIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const BackArrowIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 20 16">
      <path d="M8.8 15.51a1.72 1.72 0 000-2.37L5.46 9.65h12.93a1.68 1.68 0 000-3.36H5.51L8.8 2.86a1.72 1.72 0 000-2.37 1.57 1.57 0 00-2.27 0L.47 6.81A1.75 1.75 0 000 8a1.71 1.71 0 00.47 1.18l6.06 6.33a1.57 1.57 0 002.27 0z" />
    </Icon>
  )
}
export default BackArrowIcon
